
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface SpecializedBadgesProps {
  specialized: Array<{
    name: string;
    description?: string | null;
  }>;
}

export const SpecializedBadges: React.FC<SpecializedBadgesProps> = ({
  specialized,
}) => {
  return (
    <div className="space-y-1">
      {specialized.length > 0 ? (
        specialized.map((spec, index) => (
          <Badge
            key={index}
            variant="outline"
            className="text-xs bg-purple-50 text-purple-700 border-purple-200"
            title={spec.description || spec.name}
          >
            {spec.name}
          </Badge>
        ))
      ) : (
        <span className="text-muted-foreground">-</span>
      )}
    </div>
  );
};
